<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import Isaac from '../../General/Isaac.vue';
import { TEXT } from '../../../configs/text';

const { t } = useI18n()
</script>

<template>
    <div class="h-full flex flex-col items-center justify-evenly rounded-lg bg-black/80 p-3 overflow-auto">
        <Isaac :text="t(TEXT.wait_teacher_start_practice)" />
    </div>
</template>